import { render, staticRenderFns } from "./osComponent.vue?vue&type=template&id=67f40fc6&scoped=true&"
import script from "./osComponent.vue?vue&type=script&lang=js&"
export * from "./osComponent.vue?vue&type=script&lang=js&"
import style0 from "./osComponent.vue?vue&type=style&index=0&id=67f40fc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f40fc6",
  null
  
)

export default component.exports